export default __webpack_public_path__ + "static/media/glass-accept.33b7eb75.png";